// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mrWBzRvPu5Ydv2KyvmTg {
    position: relative;
    z-index: 301;
  overflow-x: hidden;
  }
  
  .qafchUdcjNyr4JdpOVtW {
    max-height: 100%;
    overflow-x: hidden;
    background: rgb(var(--primary-bg));
  }
  
  .pOnKC_Ch16akWqcBeENr {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    justify-items: start;
    gap: 5px;
    margin-bottom: 20px;
  }
  
  .iHHLwUSf5LVXB82rSQVy {
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    gap: 5px;
    margin-bottom: 20px;
  }
  
  
  .F8nwsOi6vsgrREYYYMOr {
    color: #1c77ff;
    font-size: 16.5px;
    font-weight: 540;
    letter-spacing: 0.43px;
    padding: 0;
    background: transparent;
    cursor: pointer;
    border: none;
    transition: color 0.3s ease 0s;
  }
  
  .F8nwsOi6vsgrREYYYMOr:hover {
    color: #055ada;
    background: transparent;
  }
  
  .lHYTD6t29JiAQ_JPUdki {
    font-size: 17px;
    font-weight: 760;
    letter-spacing: 0.43px;
    line-height: 129.41%;
    margin: 0 auto;
  }
  
  ._yivOJhQGFyqAlqo679I {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .SSPQdpj7wsmokGcAEF3J {
    position: absolute;
    right: 50%;
    top: 50%;
    z-index: 50;
    transform: translate(50%, -50%);
    padding: 0;
    background: transparent;
  }
  
  .l1yCExM1fIpFTJOTkD1V {
    padding: 14px 21px;
    font-style: 17px;
    font-weight: 540;
    line-height: 129%;
    border-radius: 30px;
    background: #007AFF;
    letter-spacing: 0.63px;
    width: 100%;
    height: auto;
    margin-top: 20px;
  }
  
  .l1yCExM1fIpFTJOTkD1V:hover {
    background: #007AFF;
  }
  
  .d32oPR2TkCqXSuMYpwIm {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  
  .qt_nVkRUJVNfTmtcpmP6 {
    font-weight: 540;
  }
  
  /* .passwordBlock {
    margin: 20px 0;
  } */
  .y4DqSzYZRIaGxzzGz_GA {
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 760;
    line-height: 120%;
  }
  .eiZ4jdL5eboNFqo9Kq_T {
    padding: 13px;
    font-size: 17px;
    width: 100%;
    border-radius: 10px;
    background: rgba(118, 118, 128, 0.12);
    border: none;
    color: rgba(60, 60, 67, 0.6);
    margin-bottom: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/pages/swap/checkpsw/checkpsw.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;EACd,kBAAkB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;;EAGA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,+BAA+B;IAC/B,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;KAEG;EACH;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,qCAAqC;IACrC,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;EACrB","sourcesContent":[".wrapper {\n    position: relative;\n    z-index: 301;\n  overflow-x: hidden;\n  }\n  \n  .modal {\n    max-height: 100%;\n    overflow-x: hidden;\n    background: rgb(var(--primary-bg));\n  }\n  \n  .modalTop {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    align-items: center;\n    justify-items: start;\n    gap: 5px;\n    margin-bottom: 20px;\n  }\n  \n  .modalTopRight {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    align-items: center;\n    gap: 5px;\n    margin-bottom: 20px;\n  }\n  \n  \n  .modalTopButton {\n    color: #1c77ff;\n    font-size: 16.5px;\n    font-weight: 540;\n    letter-spacing: 0.43px;\n    padding: 0;\n    background: transparent;\n    cursor: pointer;\n    border: none;\n    transition: color 0.3s ease 0s;\n  }\n  \n  .modalTopButton:hover {\n    color: #055ada;\n    background: transparent;\n  }\n  \n  .modalTitle {\n    font-size: 17px;\n    font-weight: 760;\n    letter-spacing: 0.43px;\n    line-height: 129.41%;\n    margin: 0 auto;\n  }\n  \n  .modalContent {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .modalContentSwap {\n    position: absolute;\n    right: 50%;\n    top: 50%;\n    z-index: 50;\n    transform: translate(50%, -50%);\n    padding: 0;\n    background: transparent;\n  }\n  \n  .button {\n    padding: 14px 21px;\n    font-style: 17px;\n    font-weight: 540;\n    line-height: 129%;\n    border-radius: 30px;\n    background: #007AFF;\n    letter-spacing: 0.63px;\n    width: 100%;\n    height: auto;\n    margin-top: 20px;\n  }\n  \n  .button:hover {\n    background: #007AFF;\n  }\n  \n  .container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n  \n  .modalContentMain {\n    font-weight: 540;\n  }\n  \n  /* .passwordBlock {\n    margin: 20px 0;\n  } */\n  .passwordLabel {\n    margin-bottom: 15px;\n    font-size: 20px;\n    font-weight: 760;\n    line-height: 120%;\n  }\n  .passwordInput {\n    padding: 13px;\n    font-size: 17px;\n    width: 100%;\n    border-radius: 10px;\n    background: rgba(118, 118, 128, 0.12);\n    border: none;\n    color: rgba(60, 60, 67, 0.6);\n    margin-bottom: 20px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `mrWBzRvPu5Ydv2KyvmTg`,
	"modal": `qafchUdcjNyr4JdpOVtW`,
	"modalTop": `pOnKC_Ch16akWqcBeENr`,
	"modalTopRight": `iHHLwUSf5LVXB82rSQVy`,
	"modalTopButton": `F8nwsOi6vsgrREYYYMOr`,
	"modalTitle": `lHYTD6t29JiAQ_JPUdki`,
	"modalContent": `_yivOJhQGFyqAlqo679I`,
	"modalContentSwap": `SSPQdpj7wsmokGcAEF3J`,
	"button": `l1yCExM1fIpFTJOTkD1V`,
	"container": `d32oPR2TkCqXSuMYpwIm`,
	"modalContentMain": `qt_nVkRUJVNfTmtcpmP6`,
	"passwordLabel": `y4DqSzYZRIaGxzzGz_GA`,
	"passwordInput": `eiZ4jdL5eboNFqo9Kq_T`
};
export default ___CSS_LOADER_EXPORT___;
